import { authRoles } from 'app/auth';
import i18next from 'i18next';

import ModelValidationLogEditForm from './editform/ModelValidationLogEditForm';
import ModelValidationLogTable from './table/ModelValidationLogTable';

import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'modelValidationLog', en);
i18next.addResourceBundle('hu', 'modelValidationLog', hu);

export default [
	{
		path: '/model-validation-log/edit/:id/:tabKey?',
		component: ModelValidationLogEditForm,
		auth: authRoles.modelValidationLog
	},
	{
		path: '/model-validation-log/:sessionNameParam?',
		component: ModelValidationLogTable,
		auth: authRoles.modelValidationLog
	}
];